export const isSecondaryMenuCollapseRoute = (pathname = "") => {
   if (typeof pathname !== "string") {
      return false;
   }

   const resultsDetailPattern = /^\/workspace\/results\/results\/[^/]+$/;
   const actionPlanDetailPattern = /^\/workspace\/results\/action-plan\/[^/]+$/;

   return resultsDetailPattern.test(pathname) || actionPlanDetailPattern.test(pathname);
};
